/* Extras for the online design studio (fsp-designer-extras.js, v3, 23 Oct 2026).
   It never changes how a design is stored or printed.
   A. "Design it for me" limits: tells the designer service which browser is asking (a random
      code kept in this browser) and, for signed-in customers, who they are, so guests get
      3 free tries a day and signed-in customers get more. No names or emails are sent.
   B. Explains those rules next to the "Design it" button, shows the tries left today and
      offers "Sign in or create a free account". All screen sizes.
   C. Phones (up to 749px wide, or a phone turned sideways): a full-screen studio that works
      like the phone design apps people already know.
      - The sign fills the screen. Top: close, Undo, Redo, Help and Finish.
      - Bottom: big labeled buttons (Size & designs, Words, Pictures, Sign color, Design it for me,
        Save). Pick something and they change to tools for it (Done, Edit words, Font, Size, Color,
        Center, Move, Bold, Copy, Delete, More).
      - Each tool opens a sheet from the bottom. The sheets hold the designer's own controls,
        so everything works exactly as on a computer.
      - "Tap to pick" row: one button per item, so nobody has to hit tiny words on the sign.
      - Fat-finger help: a finger has to move 8px before anything moves, bigger round handles,
        no rotate handle, arrow buttons to nudge, center buttons, and taps a little off an
        item still select it.
      On a phone, "Use the regular page instead" (Help) or the close button goes back to the
      regular page, and "Open the full-screen designer" comes back.
   D. Computers (v3): a full-window studio, opened by itself.
      - Top: Back to product, Undo, Redo, the 4 steps (still clickable), Help, Save, Finish.
      - Left: a column of labeled buttons (Size & designs, Words, Pictures, Shapes, Sign color,
        Design it for me). Each opens its panel beside the sign; the panels hold the designer's
        own controls, moved in and put back.
      - Above the sign: every tool for the picked item in one toolbar (the designer's own
        buttons), with Color and More options as drop-downs; a small Copy / Delete bar floats
        above the picked item. Nothing picked: Front/Back tabs and the copy buttons.
      - Bottom: the green / red line key and zoom (- % + Fit).
      - Finish opens Check & order in a window. Keys: the designer's own (arrows, Delete,
        Ctrl+Z, Ctrl+D) plus Esc to let go.
      - Help > "Use the classic layout instead" remembers the choice in this browser
        (localStorage fspk:classic); "Open the full-screen designer" clears it. */
(function () {
  if (window.__fspMobile) { return; }
  window.__fspMobile = true;

  /* A: add the browser code and, if signed in, the customer's session to AI requests. */
  (function () {
    var orig = window.fetch;
    if (!orig) { return; }
    var vid = '';
    try { vid = localStorage.getItem('fsp_ai_vid') || ''; } catch (e) { }
    if (!/^[A-Za-z0-9_-]{8,64}$/.test(vid)) {
      var a = new Uint8Array(12);
      (window.crypto && crypto.getRandomValues) ? crypto.getRandomValues(a) : a.forEach(function (x, i) { a[i] = Math.random() * 256; });
      vid = Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
      try { localStorage.setItem('fsp_ai_vid', vid); } catch (e) { }
    }
    var sess = null, sessAt = 0;
    function session() {
      if (sess && Date.now() - sessAt < 30 * 60e3) { return Promise.resolve(sess); }
      return orig.call(window, '/apps/fsp/session', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .catch(function () { return {}; })
        .then(function (s) { sess = s || {}; sessAt = Date.now(); return sess; });
    }
    window.__fspAiUsage = function () {
      if (!window.FSPD_AI_URL) { return Promise.resolve(null); }
      return session().then(function (s) {
        var h = { Accept: 'application/json', 'X-FSP-Visitor': vid };
        if (s && s.customer && s.token) { h.Authorization = 'Bearer ' + s.token; }
        return orig.call(window, window.FSPD_AI_URL.replace(/\/$/, '') + '/usage', { headers: h })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (u) { if (u) { u.signedIn = !!(s && s.customer); } return u; });
      }).catch(function () { return null; });
    };
    window.__fspSignedIn = function () { return session().then(function (s) { return !!(s && s.customer); }); };
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (window.FSPD_AI_URL && url === window.FSPD_AI_URL && init && String(init.method || '').toUpperCase() === 'POST') {
        var self = this, args = arguments;
        return session().then(function (s) {
          var h = new Headers(init.headers || {});
          h.set('X-FSP-Visitor', vid);
          if (s && s.customer && s.token) { h.set('Authorization', 'Bearer ' + s.token); }
          return orig.call(window, input, Object.assign({}, init, { headers: h })).then(function (res) {
            try { res.clone().json().then(function (j) { if (window.__fspAiResult) { window.__fspAiResult(res.status, j || {}); } }, function () { }); } catch (e) { }
            return res;
          });
        }, function () { return orig.apply(self, args); });
      }
      return orig.apply(this, arguments);
    };
  })();
  var mq = window.matchMedia('(max-width: 749px), (max-height: 500px) and (max-width: 1000px)');

  /* B: explain the "Design it for me" rules next to the button, so guests don't waste tries. */
  function aiRules() {
    var go = document.getElementById('fspd-ai-go');
    if (!go || document.querySelector('.fspd-ai-rules')) { return; }
    var txt = document.getElementById('fspd-ai-text');
    var box = document.createElement('div');
    box.className = 'fspd-ai-rules';
    var css = document.createElement('style');
    css.textContent = '.fspd-ai-rules{margin:6px 0 10px;padding:10px 12px;border:1px solid #c9d3e0;border-radius:8px;background:#f5f8fc;font-size:14px;line-height:1.45;color:#1f2a37}' +
      '.fspd-ai-rules strong{display:block;margin-bottom:4px;color:#1d4f86}.fspd-ai-rules ul{margin:4px 0 6px 18px;padding:0}.fspd-ai-rules li{margin:2px 0}' +
      '.fspd-ai-rules .fspd-ai-left{font-weight:700;margin:6px 0 4px}.fspd-ai-rules .fspd-ai-left.is-zero{color:#b42318}' +
      '.fspd-ai-rules a.fspd-ai-signin{display:inline-block;margin-top:4px;padding:8px 14px;min-height:40px;box-sizing:border-box;border-radius:6px;background:#1d4f86;color:#fff;font-weight:700;text-decoration:none}' +
      '.fspd-ai-rules.is-flash{box-shadow:0 0 0 3px #f5b400}';
    document.head.appendChild(css);
    if (txt) { txt.insertAdjacentElement('beforebegin', box); } else { (go.closest('.fspd-row') || go).insertAdjacentElement('afterend', box); }
    var signin = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
    var state = { signedIn: false, left: null, limit: null };
    function render() {
      var left = state.left == null ? '' : '<p class="fspd-ai-left' + (state.left === 0 ? ' is-zero' : '') + '">Tries left today: ' + state.left + ' of ' + state.limit + '</p>';
      if (state.signedIn) {
        box.innerHTML = '<strong>How \u201cDesign it for me\u201d works</strong>' +
          '<ul><li>You\u2019re signed in: you get ' + (state.limit || 25) + ' tries a day.</li>' +
          '<li>Each try gives you up to 3 designs. \u201cShow another\u201d flips through them and doesn\u2019t use a try.</li>' +
          '<li>You can change any design afterwards: words, colors and sizes.</li></ul>' + left;
      } else {
        box.innerHTML = '<strong>How \u201cDesign it for me\u201d works</strong>' +
          '<ul><li>Guests get <b>3 free tries a day</b>. Each try gives you up to 3 designs, and \u201cShow another\u201d flips through them without using a try.</li>' +
          '<li>Make each try count: say what the sign is for, the exact words you want on it, and your colors.</li>' +
          '<li>You can change any design afterwards: words, colors and sizes.</li></ul>' + left +
          '<p style="margin:6px 0 0">Want more? A free account gets you 25 tries a day and lets you save your designs to finish later.</p>' +
          '<a class="fspd-ai-signin" href="' + signin + '">Sign in or create a free account</a>';
      }
    }
    render();
    if (window.__fspAiUsage) {
      window.__fspAiUsage().then(function (u) {
        if (u && typeof u.remaining === 'number') { state.signedIn = !!u.customer; state.left = u.remaining; state.limit = u.limit; }
        else if (window.__fspSignedIn) { return window.__fspSignedIn().then(function (si) { state.signedIn = si; }); }
      }).then(render, render);
    }
    window.__fspAiResult = function (status, j) {
      if (typeof j.remaining === 'number') { state.left = j.remaining; if (j.limit) { state.limit = j.limit; } }
      render();
      if (status === 429 && j.error) {
        setTimeout(function () {
          var st = document.getElementById('fspd-status');
          if (st) { st.textContent = j.error; }
          box.classList.add('is-flash');
          box.scrollIntoView({ block: 'center', behavior: 'smooth' });
          setTimeout(function () { box.classList.remove('is-flash'); }, 2500);
        }, 60);
      }
    };
  }


  /* C: phones. The full-screen studio (works like the phone design apps people know). */
  var SVG = function (d, w) {
    return '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (w || 2) +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  };
  var IC = {
    x: '<path d="M6 6l12 12"/><path d="M18 6L6 18"/>',
    undo: '<path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>',
    redo: '<path d="M15 14l5-5-5-5"/><path d="M20 9H10a6 6 0 0 0 0 12h3"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14"/><path d="M12 17.5h.01"/>',
    designs: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
    words: '<path d="M4 7V5h16v2"/><path d="M12 5v14"/><path d="M9 19h6"/>',
    pictures: '<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 17l-5-5-9 8"/>',
    bg: '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>',
    ai: '<path d="M12 3l1.8 4.7 4.7 1.8-4.7 1.8L12 16l-1.8-4.7-4.7-1.8 4.7-1.8z"/><path d="M19 15l.8 2.2 2.2.8-2.2.8L19 21l-.8-2.2-2.2-.8 2.2-.8z"/>',
    save: '<path d="M5 3h11l3 3v15H5z"/><path d="M8 3v5h7V3"/><rect x="8" y="13" width="8" height="5"/>',
    check: '<path d="M5 12l5 5 9-10"/>',
    edit: '<path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/>',
    font: '<path d="M3 19l5-14 5 14"/><path d="M5 14h6"/><circle cx="17.5" cy="15.5" r="3"/><path d="M20.5 12v7"/>',
    size: '<path d="M4 20L20 4"/><path d="M14 4h6v6"/><path d="M10 20H4v-6"/>',
    color: '<circle cx="12" cy="12" r="9"/><circle cx="8" cy="10" r="1.3"/><circle cx="12" cy="7.5" r="1.3"/><circle cx="16" cy="10" r="1.3"/><circle cx="10" cy="15" r="1.3"/>',
    center: '<path d="M12 3v18"/><path d="M6 8h12"/><path d="M8 16h8"/>',
    move: '<path d="M12 3v18"/><path d="M3 12h18"/><path d="M9 6l3-3 3 3"/><path d="M9 18l3 3 3-3"/><path d="M6 9l-3 3 3 3"/><path d="M18 9l3 3-3 3"/>',
    bold: '<path d="M7 4h6a4 4 0 0 1 0 8H7z"/><path d="M7 12h7a4 4 0 0 1 0 8H7z"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
    del: '<path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M6 7l1 13h10l1-13"/>',
    more: '<circle cx="5" cy="12" r="1.6"/><circle cx="12" cy="12" r="1.6"/><circle cx="19" cy="12" r="1.6"/>',
    up: '<path d="M12 19V5"/><path d="M6 11l6-6 6 6"/>',
    down: '<path d="M12 5v14"/><path d="M6 13l6 6 6-6"/>',
    left: '<path d="M19 12H5"/><path d="M11 6l-6 6 6 6"/>',
    right: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
    shapes: '<rect x="3" y="11" width="9" height="9" rx="1"/><circle cx="16.5" cy="7.5" r="4.5"/>'
  };
  var STUDIO_CSS =
    'html.fspm-on,html.fspm-on body{overflow:hidden!important}' +
    '.fspm{position:fixed;left:0;right:0;top:0;height:100vh;height:100dvh;width:auto;max-width:none;margin:0;padding:0;z-index:2147482000;' +
    'display:flex;flex-direction:column;background:#e8ebef;color:#1b2e4a;font-size:16px;line-height:1.4;overscroll-behavior:contain}' +
    '.fspm[hidden]{display:none!important}' +
    '.fspm button{text-transform:none;letter-spacing:normal;box-shadow:none;min-width:0;margin:0;font-family:inherit}' +
    '.fspm-top{flex:0 0 auto;display:flex;align-items:center;gap:2px;min-height:60px;padding:env(safe-area-inset-top) 6px 0;background:#fff;border-bottom:1px solid #dde3ea}' +
    '.fspm-ib{flex:0 0 auto;width:48px;height:48px;display:flex;align-items:center;justify-content:center;background:none;border:0;border-radius:12px;color:#1b2e4a;padding:0;cursor:pointer}' +
    '.fspm-ib:active,.fspm-tb:active{background:#eef2f6}.fspm-ib:disabled{color:#a9b2bd}' +
    '.fspm-title{flex:1 1 auto;min-width:0;text-align:center;font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.fspm-pill{flex:0 0 auto;min-height:44px;padding:0 18px;border-radius:22px;border:0;background:#1f7a80;color:#fff;font-weight:700;font-size:15px;cursor:pointer;white-space:nowrap}' +
    '.fspm-area{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;justify-content:center;overflow:hidden;padding:8px 8px 4px;position:relative}' +
    '.fspm-area #fspd-stage-wrap{position:static!important;top:auto!important;width:100%;max-width:none!important;margin:0!important;padding:0!important;background:none!important;box-shadow:none!important;border:0!important}' +
    '.fspm-area .fspd-histbtns,.fspm-area .fspd-bar-gap,.fspm-area .fspd-bigbtn,.fspm-area .fspd-legend,.fspm-area #fspd-props{display:none!important}' +
    '.fspm-area .fspd-stagebar{justify-content:center;flex-wrap:wrap;gap:6px;margin:0 0 6px}' +
    '.fspm-area #fspd-dims{text-align:center;font-size:13px;margin:0 0 6px}' +
    '.fspm-area #fspd-warn{font-size:13px;margin:6px 0 0;max-height:76px;overflow:auto}' +
    '.fspm-area .fspd-copybtns{display:none!important}.fspm.is-back .fspm-area .fspd-copybtns{display:flex!important;flex-wrap:wrap;justify-content:center;gap:6px}' +
    '.fspm.has-sheet .fspm-area .fspd-copybtns,.fspm.has-sheet .fspm-area #fspd-dims,.fspm.has-sheet .fspm-hint{display:none!important}' +
    '.fspm-hint{text-align:center;font-size:12px;color:#4a5665;margin:6px 0 0}' +
    '.fspm-foot{flex:0 0 auto;background:#fff;border-top:1px solid #dde3ea;padding-bottom:env(safe-area-inset-bottom)}' +
    '.fspm-chips,.fspm-bar{display:flex;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}' +
    '.fspm-chips::-webkit-scrollbar,.fspm-bar::-webkit-scrollbar{display:none}' +
    '.fspm-chips{align-items:center;gap:8px;padding:10px 12px 6px}' +
    '.fspm-chipl{flex:0 0 auto;font-size:13px;font-weight:600;color:#4a5665}' +
    '.fspm-chip{flex:0 0 auto;max-width:220px;height:44px;padding:0 16px;border-radius:22px;border:2px solid #cbd3dc;background:#fff;color:#1b2e4a;font-weight:600;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}' +
    '.fspm-chip.is-on{border-color:#1e6fd9;background:#e8f1fd;color:#0f4fa8}.fspm-chip.is-add{border-style:dashed;border-color:#1f7a80;color:#15595d}' +
    '.fspm-bar{gap:2px;padding:2px 6px 8px}' +
    '.fspm-tb{flex:0 0 auto;width:74px;height:72px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;background:none;border:0;border-radius:14px;' +
    'color:#1b2e4a;font-weight:600;font-size:12.5px;line-height:1.1;cursor:pointer;padding:0 2px;text-align:center}' +
    '.fspm-tb.is-done{background:#e3f1f2;color:#15595d}.fspm-tb.is-danger{color:#b3261e}' +
    '.fspm .fspm-ctx{display:none}.fspm.is-sel .fspm-ctx{display:flex}.fspm.is-sel .fspm-dock{display:none}' +
    '.fspm.has-sheet .fspm-foot{display:none}' +
    '.fspm-sheet{flex:0 0 auto;max-height:58%;display:flex;flex-direction:column;background:#fff;border-radius:20px 20px 0 0;box-shadow:0 -6px 24px rgba(27,46,74,.16);padding-bottom:env(safe-area-inset-bottom)}' +
    '.fspm-sheet.is-tall{max-height:86%}' +
    '.fspm-sh-head{flex:0 0 auto;display:flex;align-items:center;gap:8px;padding:8px 8px 6px 18px;border-bottom:1px solid #eef1f4}' +
    '.fspm-sh-title{flex:1 1 auto;margin:0;font-size:18px;font-weight:700;color:#1b2e4a}' +
    '.fspm-sh-body{flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:12px 16px 20px}' +
    '.fspm-sh-body > * + *{margin-top:12px}' +
    '.fspm-sh-body .fspd-panel{display:block!important;padding:0!important;margin:0!important;border:0!important;box-shadow:none!important;background:none!important}' +
    '.fspm-sh-body .fspd-nav,.fspm-sh-body .fspd-panel > h2{display:none!important}' +
    '.fspm-sh-body #fspd-props{display:block!important}.fspm-sh-body .fspd-props-empty,.fspm-sh-body .fspd-props-head{display:none!important}' +
    '.fspm-sh-body .fspd-prop{flex-wrap:wrap;gap:10px}' +
    '.fspm-sh-body details.fspd-group{margin:0}' +
    '.fspm[data-sheet="designs"] .fspm-sh-body #fspd-sec-ai{display:none!important}' +
    '.fspm-big{display:flex;align-items:center;justify-content:center;gap:12px;width:100%;min-height:58px;padding:0 16px;border:2px solid #dde3ea;border-radius:14px;background:#fff;' +
    'color:#1b2e4a;font-weight:600;font-size:17px;line-height:1.2;text-align:center;cursor:pointer}.fspm-big:active{background:#f3f6f9}' +
    '.fspm-row2{display:flex;gap:10px}.fspm-row2 .fspm-big{flex:1 1 0;font-size:16px;padding:0 8px}' +
    '.fspm-note{margin:0;font-size:14px;color:#4a5665}' +
    '.fspm-pad{display:grid;grid-template-columns:repeat(3,72px);gap:8px;justify-content:center}' +
    '.fspm-pad button{height:64px;border-radius:14px;border:2px solid #dde3ea;background:#fff;color:#1b2e4a;display:flex;align-items:center;justify-content:center;padding:0;font-weight:700;font-size:13px;cursor:pointer}' +
    '.fspm-call{padding:14px;border-radius:12px;background:#f1f7f7;font-size:15px;line-height:1.45}.fspm-call a{font-weight:700;color:#15595d}' +
    '.fspm-tips{margin:0;padding:0 0 0 22px;font-size:15px;line-height:1.45}.fspm-tips li{margin:0 0 8px}' +
    '.fspm-toast{position:absolute;left:12px;right:12px;top:10px;z-index:5;padding:12px 14px;border-radius:12px;background:#1b2e4a;color:#fff;font-size:14px;font-weight:600;line-height:1.35;text-align:center;opacity:0;pointer-events:none;transition:opacity .2s}' +
    '.fspm-toast.is-on{opacity:1}' +
    /* phone turned sideways: the sign on the left, the tools on the right */
    '@media (max-height:500px) and (min-width:560px){.fspm{display:grid;grid-template-columns:minmax(0,1fr) 300px;grid-template-rows:auto minmax(0,1fr)}' +
    '.fspm-top{grid-column:1/3;min-height:50px}.fspm-area{grid-column:1;grid-row:2;padding:6px}' +
    '.fspm-foot,.fspm-sheet{grid-column:2;grid-row:2;min-height:0;border-top:0;border-left:1px solid #dde3ea}' +
    '.fspm-foot{overflow-y:auto;display:flex;flex-direction:column}.fspm-bar{order:-1;padding-top:6px}.fspm-chips,.fspm-bar{flex-wrap:wrap;overflow:visible}.fspm-tb{width:68px;height:62px}' +
    '.fspm-sheet{max-height:none!important;border-radius:0;box-shadow:none}' +
    '.fspm-area #fspd-dims,.fspm-hint{display:none!important}.fspm-area .fspd-stagebar{margin:0 0 4px}}' +
    'html.fspm-on .fspd-status{bottom:calc(172px + env(safe-area-inset-bottom))!important}' +
    'html.fspm-on.fspm-sheet-on .fspd-status{bottom:auto!important;top:calc(72px + env(safe-area-inset-top))!important}' +
    'html.fspm-on .chatway--trigger-container,html.fspm-on .fspd-mini{display:none!important}' +
    '@media (max-height:500px) and (min-width:560px){html.fspm-on .fspd-status,html.fspm-on.fspm-sheet-on .fspd-status{top:auto!important;bottom:12px!important}}' +
    '.fspd-bigbtn{display:inline-block;margin:8px 0 4px;padding:10px 16px;min-height:48px;border:2px solid #1f7a80;border-radius:24px;background:#fff;color:#15595d;font:inherit;font-weight:700;font-size:15px;cursor:pointer}';

  function makeStudio(stage, mqPhone, onFitChange) {
    var root = document.getElementById('fsp-designer');
    var wrap = document.getElementById('fspd-stage-wrap');
    if (!root || !wrap || !window.FSPD || !window.FSPD.canvas) { return null; }
    var canvas = window.FSPD.canvas;
    var $ = function (id) { return document.getElementById(id); };
    var home = { p: wrap.parentNode, n: wrap.nextSibling };
    var h1 = root.querySelector('h1');
    var title = h1 && h1.firstChild ? String(h1.firstChild.textContent || '').trim() : 'Your sign';
    var tb = function (a, icon, label, cls) {
      return '<button type="button" class="fspm-tb' + (cls ? ' ' + cls : '') + '" data-a="' + a + '">' + SVG(IC[icon], a === 'deselect' || a === 'bold' ? 2.4 : 2) + '<span>' + label + '</span></button>';
    };
    var el = document.createElement('div');
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Sign designer');
    el.innerHTML =
      '<div class="fspm-top">' +
      '<button type="button" class="fspm-ib" data-a="exit" aria-label="Close full screen">' + SVG(IC.x) + '</button>' +
      '<button type="button" class="fspm-ib" data-a="undo" aria-label="Undo">' + SVG(IC.undo) + '</button>' +
      '<button type="button" class="fspm-ib" data-a="redo" aria-label="Redo">' + SVG(IC.redo) + '</button>' +
      '<div class="fspm-title"></div>' +
      '<button type="button" class="fspm-ib" data-a="help" aria-label="Help">' + SVG(IC.help) + '</button>' +
      '<button type="button" class="fspm-pill" data-a="finish">Finish</button></div>' +
      '<div class="fspm-area"><div class="fspm-toast" role="status" aria-live="polite"></div><p class="fspm-hint">Keep words and logos inside the green line</p></div>' +
      '<div class="fspm-foot"><div class="fspm-chips"></div>' +
      '<div class="fspm-bar fspm-dock">' + tb('designs', 'designs', 'Size &amp; designs') + tb('words', 'words', 'Words') + tb('pictures', 'pictures', 'Pictures') +
      tb('bg', 'bg', 'Sign color') + tb('ai', 'ai', 'Design it for me') + tb('save', 'save', 'Save') + '</div>' +
      '<div class="fspm-bar fspm-ctx">' + tb('deselect', 'check', 'Done', 'is-done') + tb('edit', 'edit', 'Edit words') + tb('font', 'font', 'Font') +
      tb('size', 'size', 'Size') + tb('color', 'color', 'Color') + tb('center', 'center', 'Center') + tb('move', 'move', 'Move') + tb('bold', 'bold', 'Bold') +
      tb('copy', 'copy', 'Copy') + tb('del', 'del', 'Delete', 'is-danger') + tb('more', 'more', 'More') + '</div></div>' +
      '<section class="fspm-sheet" hidden aria-labelledby="fspm-sh-t"><div class="fspm-sh-head"><div class="fspm-sh-title" id="fspm-sh-t" role="heading" aria-level="2"></div>' +
      '<button type="button" class="fspm-pill" data-a="close">Done</button></div><div class="fspm-sh-body"></div></section>';
    root.appendChild(el);
    var q = function (s) { return el.querySelector(s); };
    q('.fspm-title').textContent = title;
    var area = q('.fspm-area'), hint = q('.fspm-hint'), chips = q('.fspm-chips'), sheet = q('.fspm-sheet'), body = q('.fspm-sh-body');
    function onBack() { var st = window.FSPD.state || {}; return st.current === 1; }
    function syncClass() { el.className = 'fspm' + (S.sel ? ' is-sel' : '') + (S.sheet ? ' has-sheet' : '') + (onBack() ? ' is-back' : ''); }
    var S = { on: false, sheet: null, moved: [], sel: false, scale: 1, closedByUser: false };
    new MutationObserver(function () { syncClass(); fitSoon(); }).observe(wrap.querySelector('.fspd-sides') || wrap, { attributes: true, subtree: true, attributeFilter: ['class'] });
    syncClass();

    var toastT;
    function toast(msg, ms) {
      var t = q('.fspm-toast');
      t.textContent = msg;
      t.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { t.classList.remove('is-on'); }, ms || 3200);
    }
    function click(id) { var b = $(id); if (b && !b.disabled) { b.click(); return true; } return false; }
    function step(n) { var b = root.querySelectorAll('.fspd-step')[n - 1]; if (b) { b.click(); } }
    function panel(i) { return root.querySelectorAll('.fspd-tools > .fspd-panel')[i] || document.querySelectorAll('.fspd-panel')[i]; }
    function active() { return canvas.getActiveObject(); }
    function changed(o) {
      o.setCoords();
      canvas.requestRenderAll();
      canvas.fire('object:modified', { target: o });
    }

    /* the sign: fill the space it has */
    function fit() {
      if (!S.on) { return; }
      var w = parseFloat(stage.style.width) || stage.offsetWidth, h = parseFloat(stage.style.height) || stage.offsetHeight;
      if (!w || !h) { return; }
      var others = wrap.offsetHeight - stage.getBoundingClientRect().height;
      var availW = area.clientWidth - 16;
      var availH = area.clientHeight - others - hint.offsetHeight - 22;
      var s = Math.max(0.2, Math.min(availW / w, availH / h, 4));
      if (Math.abs(s - S.scale) < 0.002 && stage.style.transform) { return; }
      S.scale = s;
      stage.style.transformOrigin = 'top left';
      stage.style.transform = 'scale(' + s.toFixed(4) + ')';
      stage.style.marginBottom = Math.round(h * (s - 1)) + 'px';
      stage.style.marginRight = Math.round(w * (s - 1)) + 'px';
      stage.style.marginLeft = Math.max(0, Math.round((availW - w * s) / 2)) + 'px';
      handles();
    }
    var fitQ = false;
    /* the editor keeps where the sign sits on the page; tell it after every move or resize, or taps land in the wrong place */
    function fitSoon() { if (!fitQ) { fitQ = true; requestAnimationFrame(function () { fitQ = false; fit(); canvas.calcOffset(); }); } }
    if (window.ResizeObserver) { new ResizeObserver(fitSoon).observe(area); }
    new MutationObserver(fitSoon).observe(stage, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', fitSoon);

    /* bigger handles that stay big however the sign is scaled; no rotate handle */
    var P = fabric.Object.prototype, keep = { cs: P.cornerSize, tcs: P.touchCornerSize };
    function mtr(on) {
      [fabric.Object, fabric.Textbox, fabric.IText].forEach(function (k) {
        var c = k && k.prototype && k.prototype.controls;
        if (c && c.mtr) { c.mtr.visible = on; }
      });
    }
    function handles() {
      if (S.on) {
        P.cornerSize = Math.round(Math.max(keep.cs || 16, 24 / S.scale));
        P.touchCornerSize = Math.round(Math.max(keep.tcs || 34, 48 / S.scale));
      } else { P.cornerSize = keep.cs; P.touchCornerSize = keep.tcs; }
      canvas.getObjects().forEach(function (o) {
        if (Object.prototype.hasOwnProperty.call(o, 'cornerSize')) { o.cornerSize = P.cornerSize; o.touchCornerSize = P.touchCornerSize; }
      });
      canvas.requestRenderAll();
    }

    /* a finger has to really move before anything moves */
    var drag = null;
    canvas.on('mouse:down', function (e) {
      drag = (S.on && e.target) ? { o: e.target, x: e.target.left, y: e.target.top, p: canvas.getPointer(e.e), moved: false } : null;
    });
    canvas.on('object:moving', function (e) {
      if (!drag || drag.moved || e.target !== drag.o) { return; }
      var p = canvas.getPointer(e.e);
      if (Math.sqrt(Math.pow(p.x - drag.p.x, 2) + Math.pow(p.y - drag.p.y, 2)) * S.scale < 8) {
        e.target.set({ left: drag.x, top: drag.y });
        e.target.setCoords();
      } else { drag.moved = true; }
    });

    /* the "Tap to pick" row */
    var list = [];
    function label(o) {
      if (o.fspName) { return String(o.fspName); }
      if (/text/i.test(o.type)) { return String(o.text || '').split('\n')[0].trim() || '(empty words)'; }
      if (o.type === 'image') { return 'Picture'; }
      if (o.type === 'rect') { return 'Color band'; }
      if (o.type === 'group') { return 'Group'; }
      return 'Shape';
    }
    function drawChips() {
      if (!S.on) { return; }
      syncClass();
      var a = active();
      list = canvas.getObjects().filter(function (o) { return o.selectable !== false && o.evented !== false && o.visible !== false; });
      chips.innerHTML = '<span class="fspm-chipl">Tap to pick:</span>';
      list.forEach(function (o, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fspm-chip' + (a && (a === o || (a.type === 'activeSelection' && a.contains && a.contains(o))) ? ' is-on' : '');
        b.setAttribute('data-i', i);
        var t = label(o);
        b.textContent = t.length > 22 ? t.slice(0, 21) + '…' : t;
        chips.appendChild(b);
      });
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'fspm-chip is-add';
      add.setAttribute('data-a', 'addwords');
      add.textContent = '+ Add words';
      chips.appendChild(add);
    }
    var chipQ = false;
    function chipsSoon() { if (!chipQ) { chipQ = true; requestAnimationFrame(function () { chipQ = false; drawChips(); }); } }
    function rowShown(r) { return !!r && !r.hidden; }
    function ctx() {
      var o = active();
      S.sel = !!o && S.on;
      syncClass();
      if (o) {
        var isText = /text/i.test(o.type);
        ['edit', 'font', 'bold'].forEach(function (a) { q('[data-a="' + a + '"]').hidden = !isText; });
        var fill = $('fspd-fill-sw');
        q('[data-a="color"]').hidden = !rowShown(fill && fill.closest('.fspd-prop'));
      } else if (S.sheet && SHEETS[S.sheet] && SHEETS[S.sheet].sel) { closeSheet(); }
      chipsSoon();
    }
    ['selection:created', 'selection:updated', 'selection:cleared'].forEach(function (ev) { canvas.on(ev, function () { setTimeout(ctx, 0); }); });
    ['object:added', 'object:removed', 'object:modified', 'text:changed'].forEach(function (ev) { canvas.on(ev, chipsSoon); });

    /* the sheets that slide up from the bottom */
    var callA = root.querySelector('.fspd-phone');
    var tel = callA ? callA.getAttribute('href') : 'tel:+15617472377';
    var telText = callA ? callA.textContent.trim() : '(561) 747-2377';
    var SHEETS = {
      designs: { t: 'Size & designs', step: 1, nodes: function () { return [$('fspd-draft'), panel(0)]; }, after: '<button type="button" class="fspm-big" data-a="startover">Start over with a blank sign</button>' },
      words: { t: 'Your words', step: 2, nodes: function () { return [panel(1)]; } },
      pictures: { t: 'Pictures & extras', step: 3, nodes: function () { return [panel(2)]; } },
      bg: { t: 'Sign color', nodes: function () { var b = $('fspd-bg-sw'); return [b && b.closest('details')]; }, open: true },
      ai: { t: 'Design it for me', nodes: function () { return [$('fspd-sec-ai')]; }, open: true },
      save: { t: 'Save your design', nodes: function () { return [$('fspd-savebar'), $('fspd-savebox')]; } },
      order: { t: 'Check & order', step: 4, tall: true, done: 'Back to design', nodes: function () { return [panel(3)]; } },
      font: { t: 'Font & style', sel: true, nodes: function () { var f = $('fspd-font'); return [f && f.closest('.fspd-prop')]; } },
      color: { t: 'Color', sel: true, nodes: function () { var f = $('fspd-fill-sw'); return [f && f.closest('.fspd-prop')]; } },
      more: { t: 'More options', sel: true, tall: true, nodes: function () { return [$('fspd-props')]; } },
      size: {
        t: 'Size', sel: true, html: '<div class="fspm-row2"><button type="button" class="fspm-big" data-a="smaller">− Smaller</button>' +
          '<button type="button" class="fspm-big" data-a="bigger">+ Bigger</button></div><p class="fspm-note">Tip: you can also drag a round corner of it on the sign.</p>'
      },
      move: {
        t: 'Move', sel: true, html: '<p class="fspm-note">Tap the arrows to nudge it a quarter inch at a time. Dragging it on the sign works too.</p>' +
          '<div class="fspm-pad"><span></span><button type="button" data-a="up" aria-label="Move up">' + SVG(IC.up, 2.4) + '</button><span></span>' +
          '<button type="button" data-a="left" aria-label="Move left">' + SVG(IC.left, 2.4) + '</button><button type="button" data-a="cxy">Middle</button>' +
          '<button type="button" data-a="right" aria-label="Move right">' + SVG(IC.right, 2.4) + '</button><span></span>' +
          '<button type="button" data-a="down" aria-label="Move down">' + SVG(IC.down, 2.4) + '</button><span></span></div>' +
          '<div class="fspm-row2"><button type="button" class="fspm-big" data-a="cx">Center left to right</button><button type="button" class="fspm-big" data-a="cy">Center top to bottom</button></div>'
      },
      help: {
        t: 'Help', html: '<div class="fspm-call">Stuck, or rather talk to a person? Call <a href="' + tel + '">' + telText + '</a> and we’ll help you.</div>' +
          '<button type="button" class="fspm-big" data-a="chat">Chat with us</button>' +
          '<button type="button" class="fspm-big" data-a="tips">Quick tips for designing on a phone</button>' +
          '<button type="button" class="fspm-big" data-a="classic">Use the regular page instead</button>'
      },
      tips: {
        t: 'Designing on your phone', html: '<ol class="fspm-tips">' +
          '<li><b>Tap anything on your sign</b> to pick it, or tap its name in the row under the sign.</li>' +
          '<li><b>The buttons at the bottom change</b> to tools for what you picked: words, font, size, color, center, move, copy and delete.</li>' +
          '<li><b>Drag it to move it.</b> Drag a round corner to make it bigger or smaller. It snaps to the middle of the sign.</li>' +
          '<li><b>Made a mistake?</b> Tap Undo at the top.</li>' +
          '<li><b>When it looks right,</b> tap Finish to check your sign and order.</li></ol>' +
          '<button type="button" class="fspm-pill" data-a="close" style="width:100%">Got it</button>'
      }
    };
    function closeSheet() {
      if (!S.sheet) { return; }
      for (var i = S.moved.length - 1; i >= 0; i--) {
        var m = S.moved[i];
        try { m.p.insertBefore(m.n, m.nx && m.nx.parentNode === m.p ? m.nx : null); } catch (e) { }
      }
      S.moved = [];
      body.innerHTML = '';
      sheet.hidden = true;
      S.sheet = null;
      el.removeAttribute('data-sheet');
      document.documentElement.classList.remove('fspm-sheet-on');
      syncClass();
      fitSoon();
      chipsSoon();
    }
    function openSheet(name) {
      var d = SHEETS[name];
      if (!d) { return; }
      closeSheet();
      if (d.step) { step(d.step); }
      S.sheet = name;
      el.setAttribute('data-sheet', name);
      q('#fspm-sh-t').textContent = d.t;
      q('[data-a="close"]').textContent = d.done || 'Done';
      sheet.classList.toggle('is-tall', !!d.tall);
      if (d.nodes) {
        d.nodes().forEach(function (n) {
          if (!n) { return; }
          S.moved.push({ n: n, p: n.parentNode, nx: n.nextSibling });
          body.appendChild(n);
          if (d.open && n.tagName === 'DETAILS') { n.open = true; }
        });
      }
      if (d.html) { body.insertAdjacentHTML('beforeend', d.html); }
      if (d.after) { body.insertAdjacentHTML('beforeend', d.after); }
      sheet.hidden = false;
      body.scrollTop = 0;
      document.documentElement.classList.add('fspm-sheet-on');
      syncClass();
      fitSoon();
    }
    function focusWords(add) {
      setTimeout(function () {
        var t = null, o = active();
        if (add) { t = $('fspd-text'); }
        else if (o && /text/i.test(o.type)) {
          var all = body.querySelectorAll('#fspd-words textarea');
          for (var i = 0; i < all.length; i++) { if (all[i].value === o.text) { t = all[i]; break; } }
        }
        if (t) { t.scrollIntoView({ block: 'center' }); t.focus(); }
      }, 60);
    }
    function nudge(dx, dy) {
      var o = active();
      if (!o) { return; }
      var st = window.FSPD.state || {}, d = (st.ppi || 16) * 0.25;
      o.set({ left: o.left + dx * d, top: o.top + dy * d });
      changed(o);
    }
    function centerOn(x, y) {
      var o = active();
      if (!o) { return; }
      var c = o.getCenterPoint();
      var z = canvas.getZoom() || 1;
      o.setPositionByOrigin(new fabric.Point(x ? canvas.getWidth() / z / 2 : c.x, y ? canvas.getHeight() / z / 2 : c.y), 'center', 'center');
      changed(o);
    }
    var ACT = {
      exit: function () { S.closedByUser = true; close(); },
      classic: function () { S.closedByUser = true; close(); },
      undo: function () { click('fspd-undo'); }, redo: function () { click('fspd-redo'); },
      help: function () { openSheet('help'); }, tips: function () { openSheet('tips'); },
      chat: function () { closeSheet(); if (!click('fspd-chat')) { toast('Chat isn’t available right now. Please call us.'); } },
      finish: function () { canvas.discardActiveObject(); canvas.requestRenderAll(); openSheet('order'); },
      close: function () { closeSheet(); },
      designs: function () { openSheet('designs'); }, words: function () { openSheet('words'); },
      pictures: function () { openSheet('pictures'); }, bg: function () { openSheet('bg'); },
      ai: function () { openSheet('ai'); }, save: function () { openSheet('save'); },
      addwords: function () { canvas.discardActiveObject(); canvas.requestRenderAll(); openSheet('words'); focusWords(true); },
      startover: function () { closeSheet(); click('fspd-startover'); },
      deselect: function () { canvas.discardActiveObject(); canvas.requestRenderAll(); },
      edit: function () { openSheet('words'); focusWords(false); },
      font: function () { openSheet('font'); }, color: function () { openSheet('color'); },
      size: function () { openSheet('size'); }, move: function () { openSheet('move'); }, more: function () { openSheet('more'); },
      center: function () { if (!click('fspd-center')) { centerOn(true, false); } toast('Centered left to right.', 1800); },
      bold: function () { click('fspd-bold'); }, copy: function () { click('fspd-dup'); },
      del: function () { if (click('fspd-del')) { toast('Deleted. Changed your mind? Tap Undo at the top.'); } },
      smaller: function () { click('fspd-smaller'); }, bigger: function () { click('fspd-bigger'); },
      up: function () { nudge(0, -1); }, down: function () { nudge(0, 1); }, left: function () { nudge(-1, 0); }, right: function () { nudge(1, 0); },
      cx: function () { centerOn(true, false); }, cy: function () { centerOn(false, true); }, cxy: function () { centerOn(true, true); }
    };
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (!b || !el.contains(b)) { return; }
      if (S.sheet === 'order' && b.closest('#fspd-checks')) {
        setTimeout(function () {
          closeSheet();
          var ps = root.querySelectorAll('.fspd-tools > .fspd-panel'), i = -1;
          Array.prototype.forEach.call(ps, function (p, k) { if (p.classList.contains('is-on')) { i = k; } });
          if (i === 1 && !active()) { openSheet('words'); }
          else if (i === 2) { openSheet('pictures'); }
        }, 60);
        return;
      }
      if (S.sheet === 'designs' && b.closest('#fspd-tpl-grid, #fspd-blank')) {
        setTimeout(function () { closeSheet(); toast('Tap anything on your sign to change it.', 2600); }, 350);
        return;
      }
      var a = b.getAttribute('data-a');
      if (a && ACT[a]) { e.preventDefault(); ACT[a](); return; }
      var i = b.getAttribute('data-i');
      if (i != null && list[+i]) { canvas.setActiveObject(list[+i]); canvas.requestRenderAll(); }
    });

    /* undo / redo buttons follow the designer's own */
    function hist() {
      ['undo', 'redo'].forEach(function (k) { var src = $('fspd-' + k); q('[data-a="' + k + '"]').disabled = !!(src && src.disabled); });
    }
    ['fspd-undo', 'fspd-redo'].forEach(function (id) { var b = $(id); if (b) { new MutationObserver(hist).observe(b, { attributes: true, attributeFilter: ['disabled'] }); } });

    /* the keyboard on a phone shrinks the screen: keep the studio inside what's left */
    var vv = window.visualViewport;
    function vvFit() {
      if (!S.on || !vv) { return; }
      el.style.height = Math.round(vv.height) + 'px';
      el.style.top = Math.round(vv.offsetTop) + 'px';
      fitSoon();
    }
    if (vv) { vv.addEventListener('resize', vvFit); vv.addEventListener('scroll', vvFit); }

    /* the page's guided tour points at the regular layout: show the phone tips instead */
    new MutationObserver(function (ms) {
      if (!S.on) { return; }
      ms.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && n.classList.contains('fspd-tour')) {
            var skip = n.querySelector('.fspd-tour-skip');
            setTimeout(function () { if (skip) { skip.click(); } else if (n.parentNode) { n.parentNode.removeChild(n); } openSheet('tips'); }, 0);
          }
        });
      });
    }).observe(document.body, { childList: true });

    var aiSec = $('fspd-sec-ai');
    function aiBtn() { q('[data-a="ai"]').hidden = !aiSec || aiSec.hidden; }
    if (aiSec) { new MutationObserver(aiBtn).observe(aiSec, { attributes: true, attributeFilter: ['hidden'] }); }

    function open() {
      if (S.on) { return; }
      S.on = true;
      S.scale = 1;
      area.insertBefore(wrap, hint);
      el.hidden = false;
      document.documentElement.classList.add('fspm-on');
      document.body.classList.add('fspm-on');
      mtr(false);
      aiBtn();
      var bgd = $('fspd-bg-sw');
      bgd = bgd && bgd.closest('details');
      q('[data-a="bg"]').hidden = !bgd || bgd.hidden || getComputedStyle(bgd).display === 'none';
      q('[data-a="save"]').hidden = !$('fspd-save');
      hist();
      ctx();
      vvFit();
      fit();
      canvas.calcOffset();
      onFitChange && onFitChange();
      var seen = null;
      try { seen = localStorage.getItem('fspm:tips'); localStorage.setItem('fspm:tips', '1'); } catch (e) { }
      if (!seen) { openSheet('tips'); }
      else {
        var dr = $('fspd-draft');
        if (dr && !dr.hidden) { toast('We brought back the sign you were working on. To start fresh, tap Size & designs.', 5000); }
      }
    }
    function close() {
      if (!S.on) { return; }
      closeSheet();
      S.on = false;
      S.sel = false;
      home.p.insertBefore(wrap, home.n && home.n.parentNode === home.p ? home.n : null);
      el.hidden = true;
      el.style.height = '';
      el.style.top = '';
      document.documentElement.classList.remove('fspm-on', 'fspm-sheet-on');
      document.body.classList.remove('fspm-on');
      mtr(true);
      stage.style.transform = '';
      stage.style.marginBottom = stage.style.marginRight = stage.style.marginLeft = '';
      handles();
      onFitChange && onFitChange();
      stage.scrollIntoView({ block: 'center' });
      requestAnimationFrame(function () { canvas.calcOffset(); });
    }
    if (mqPhone.addEventListener) {
      mqPhone.addEventListener('change', function () {
        if (!mqPhone.matches && S.on) { close(); }
        else if (mqPhone.matches && !S.on && !S.closedByUser) { open(); }
      });
    }
    return { open: open, close: close, isOn: function () { return S.on; }, userClosed: function () { return S.closedByUser; } };
  }


  /* D: computers. The full-window studio: tools in a column on the left, their panel beside the
     sign, every tool for the picked item in one toolbar above the sign. */
  var DESK_CSS =
    'html.fspk-on,html.fspk-on body{overflow:hidden!important}' +
    '.fspk{position:fixed;left:0;top:0;right:0;bottom:0;z-index:2147482000;display:flex;flex-direction:column;background:#e8ebef;color:#1b2e4a;font-size:15px;line-height:1.4}' +
    '.fspk[hidden]{display:none!important}' +
    '.fspk button{text-transform:none;letter-spacing:normal;margin:0;font-family:inherit}' +
    '.fspk-top{flex:0 0 auto;display:flex;align-items:center;gap:10px;min-height:64px;padding:8px 16px;background:#fff;border-bottom:1px solid #dde3ea}' +
    '.fspk-top > *{flex-shrink:0}' +
    '.fspk-name{flex:0 1 auto;min-width:60px;max-width:260px;font-weight:700;font-size:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.fspk-steps{flex:1 1 auto;min-width:0;display:flex;justify-content:center;align-items:center;gap:4px;color:#9aa5b1;overflow:hidden}' +
    '@media (max-width:1280px){.fspk-steps > span{display:none}.fspk-step{padding:0 8px}}@media (max-width:1120px){.fspk-steps{visibility:hidden}}' +
    '.fspk-step{height:36px;padding:0 12px;border-radius:18px;border:0;background:none;color:#4a5665;font-weight:600;font-size:13px;cursor:pointer;white-space:nowrap}' +
    '.fspk-step:hover{background:#eef2f6}.fspk-step.is-on{background:#e3f1f2;color:#15595d}' +
    '.fspk-ghost{height:40px;padding:0 16px;border-radius:20px;border:1px solid #cbd3dc;background:#fff;color:#1b2e4a;font-weight:600;font-size:14px;cursor:pointer;white-space:nowrap}' +
    '.fspk-ghost:hover,.fspk-tbb:hover,.fspk-big:hover{background:#f3f6f9}' +
    '.fspk-tbb{height:40px;padding:0 12px;display:inline-flex;align-items:center;gap:6px;border:1px solid #cbd3dc;border-radius:10px;background:#fff;color:#1b2e4a;font-weight:600;font-size:14px;cursor:pointer}' +
    '.fspk-tbb:disabled{color:#a9b2bd;cursor:default;background:#fff}' +
    '.fspk-pill{height:44px;padding:0 22px;border-radius:22px;border:0;background:#1f7a80;color:#fff;font-weight:700;font-size:15px;cursor:pointer;white-space:nowrap}.fspk-pill:hover{background:#196569}' +
    '.fspk-body{flex:1 1 auto;min-height:0;display:flex}' +
    '.fspk-rail{flex:0 0 96px;display:flex;flex-direction:column;align-items:center;gap:4px;padding:12px 8px;background:#fff;border-right:1px solid #dde3ea;overflow-y:auto}' +
    '.fspk-rb{width:80px;min-height:74px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:6px 4px;background:none;border:0;border-radius:12px;' +
    'color:#1b2e4a;font-weight:600;font-size:12.5px;line-height:1.15;text-align:center;cursor:pointer}' +
    '.fspk-rb:hover{background:#eef2f6}.fspk-rb.is-on{background:#e3f1f2;color:#15595d}' +
    '.fspk-panel{flex:0 0 340px;display:flex;flex-direction:column;min-height:0;background:#fff;border-right:1px solid #dde3ea}' +
    '.fspk-ph{flex:0 0 auto;display:flex;align-items:center;gap:8px;padding:14px 12px 10px 20px;border-bottom:1px solid #eef1f4}' +
    '.fspk-pt{flex:1 1 auto;margin:0;font-size:18px;font-weight:700;color:#1b2e4a}' +
    '.fspk-pb{flex:1 1 auto;min-height:0;overflow-y:auto;padding:14px 20px 24px}' +
    '.fspk-pb > * + *,.fspk-mb > * + *{margin-top:12px}' +
    '.fspk-pb .fspd-panel,.fspk-mb .fspd-panel{display:block!important;padding:0!important;margin:0!important;border:0!important;box-shadow:none!important;background:none!important}' +
    '.fspk-pb .fspd-nav,.fspk-pb .fspd-panel > h2,.fspk-mb .fspd-nav,.fspk-mb .fspd-panel > h2{display:none!important}' +
    '.fspk[data-panel="designs"] .fspk-pb #fspd-sec-ai{display:none!important}' +
    '.fspk-pb details.fspd-group{margin:0}' +
    '.fspk-center{flex:1 1 auto;min-width:0;display:flex;flex-direction:column}' +
    '.fspk-center #fspd-stage-wrap{flex:1 1 auto;min-height:0;position:relative!important;top:auto!important;display:flex;flex-direction:column;width:auto;max-width:none!important;' +
    'margin:0!important;padding:0 0 24px!important;background:none!important;box-shadow:none!important;border:0!important;overflow:auto}' +
    '.fspk-tools{flex:0 0 auto;min-height:108px;display:flex;align-items:stretch;background:#fff;border-bottom:1px solid #dde3ea;position:relative;z-index:8}' +
    '.fspk-tools .fspd-stagebar,.fspk-tools #fspd-props{flex:1 1 auto;min-width:0;box-sizing:border-box;display:flex;flex-direction:row!important;flex-wrap:wrap;justify-content:flex-start;align-items:center;align-content:center;gap:8px 14px;' +
    'margin:0!important;padding:10px 16px!important;background:#fff!important;border:0!important;border-radius:0!important;box-shadow:none!important}' +
    '.fspk:not(.is-sel) .fspk-tools #fspd-props,.fspk.is-sel .fspk-tools .fspd-stagebar{display:none!important}' +
    '.fspk-tools .fspd-props-head,.fspk-tools .fspd-props-empty,.fspk-tools .fspd-histbtns,.fspk-tools .fspd-bar-gap{display:none!important}' +
    '.fspk-center .fspd-bigbtn,.fspk-center .fspd-legend{display:none!important}' +
    '.fspk-tools .fspd-prop{flex:0 0 auto;width:auto!important;display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin:0!important;padding:0!important;border:0!important}' +
    '.fspk-tools details.fspd-more{flex:0 0 auto;width:auto!important;border:0!important;padding:0!important}' +
    '.fspk-tools .fspd-prop[hidden],.fspk-tools .fspd-prop[data-for="groupcolor"],.fspk-tools .fspd-prop[data-for="qr"]{display:none!important}' +
    '.fspk-tools .fspd-prop[data-for="color"]{position:relative;flex:0 0 auto}.fspk-tools .fspd-prop[data-for="color"] > .fspd-lbl{display:none}' +
    '.fspk-tools .fspd-prop[data-for="color"] .fspd-swatches{display:none!important;position:absolute;left:0;top:calc(100% + 6px);z-index:20;width:372px;flex-wrap:wrap;gap:6px;margin:0;padding:12px;' +
    'background:#fff;border:1px solid #dde3ea;border-radius:12px;box-shadow:0 10px 30px rgba(27,46,74,.18)}' +
    '.fspk-tools .fspd-prop[data-for="color"].is-open .fspd-swatches{display:flex!important}' +
    '.fspk-dot{display:inline-block;width:18px;height:18px;border-radius:50%;border:1px solid #b9c2cc;box-sizing:border-box}' +
    '.fspk-tools details.fspd-more{position:relative;margin:0!important}' +
    '.fspk-tools details.fspd-more > summary{list-style:none;display:inline-flex;align-items:center;height:38px;padding:0 14px;border:1px solid #cbd3dc;border-radius:10px;background:#fff;font-weight:600;font-size:14px;cursor:pointer}' +
    '.fspk-tools details.fspd-more > summary::-webkit-details-marker{display:none}' +
    '.fspk-tools details.fspd-more[open] > :not(summary){position:absolute;right:0;top:calc(100% + 6px);z-index:20;width:360px;max-height:60vh;overflow:auto;margin:0;padding:14px;' +
    'background:#fff;border:1px solid #dde3ea;border-radius:12px;box-shadow:0 10px 30px rgba(27,46,74,.18)}' +
    '.fspk-center #fspd-dims{text-align:center;margin:12px 0 0!important;font-size:13px;color:#4a5665}' +
    '.fspk-center #fspd-stage{flex:0 0 auto;align-self:flex-start}' +
    '.fspk-center #fspd-warn,.fspk-center #fspd-banner-note,.fspk-center #fspd-surface-note{margin:10px auto 0!important;max-width:720px}' +
    '.fspk-strip{flex:0 0 auto;display:flex;align-items:center;gap:16px;min-height:48px;padding:6px 16px;background:#fff;border-top:1px solid #dde3ea;font-size:13px;color:#4a5665;white-space:nowrap;overflow:hidden}' +
    '.fspk-k{display:inline-flex;align-items:center;gap:6px}.fspk-kg{width:22px;border-top:2px dashed #3c9a4b}.fspk-kr{width:22px;border-top:2px solid #d93025}' +
    '.fspk-gap{flex:1 1 auto}.fspk-zl{min-width:48px;text-align:center;font-weight:700;color:#1b2e4a}' +
    '.fspk-hint{margin-left:auto;font-size:14px;color:#4a5665}' +
    '.fspk-pop{position:absolute;z-index:6;display:flex;gap:2px;padding:4px;border-radius:12px;background:#fff;box-shadow:0 4px 14px rgba(27,46,74,.22);transform:translate(-50%,-100%)}' +
    '.fspk-pop[hidden]{display:none!important}' +
    '.fspk-pop button{height:34px;padding:0 12px;border:0;border-radius:8px;background:none;color:#1b2e4a;font-weight:600;font-size:13px;cursor:pointer}' +
    '.fspk-pop button:hover{background:#eef2f6}.fspk-pop .is-danger{color:#b3261e}' +
    '.fspk-modal{position:absolute;left:0;top:0;right:0;bottom:0;z-index:30;display:flex;align-items:flex-start;justify-content:center;padding:40px 24px;background:rgba(27,46,74,.45);overflow:auto}' +
    '.fspk-modal[hidden]{display:none!important}' +
    '.fspk-dlg{width:100%;max-width:760px;background:#fff;border-radius:18px;box-shadow:0 16px 48px rgba(27,46,74,.3);display:flex;flex-direction:column}' +
    '.fspk-mh{display:flex;align-items:center;gap:12px;padding:18px 20px 12px 28px;border-bottom:1px solid #eef1f4}' +
    '.fspk-mt{flex:1 1 auto;margin:0;font-size:22px;font-weight:700;color:#1b2e4a}' +
    '.fspk-mb{padding:18px 28px 28px}' +
    '.fspk-toast{position:absolute;left:50%;top:76px;transform:translateX(-50%);z-index:40;max-width:560px;padding:12px 18px;border-radius:12px;background:#1b2e4a;color:#fff;' +
    'font-size:14px;font-weight:600;line-height:1.35;text-align:center;opacity:0;pointer-events:none;transition:opacity .2s}.fspk-toast.is-on{opacity:1}' +
    '.fspk-call{padding:14px;border-radius:12px;background:#f1f7f7;font-size:15px;line-height:1.45}.fspk-call a{font-weight:700;color:#15595d}' +
    '.fspk-big{display:flex;align-items:center;width:100%;min-height:50px;padding:0 16px;border:1px solid #dde3ea;border-radius:12px;background:#fff;color:#1b2e4a;font-weight:600;font-size:15px;text-align:left;cursor:pointer}' +
    '.fspk-note{margin:0;font-size:14px;color:#4a5665;line-height:1.5}' +
    'html.fspk-on .fspd-status{bottom:72px!important}' +
    'html.fspk-on .chatway--trigger-container,html.fspk-on .fspd-mini{display:none!important}';

  function makeDesk(stage, mqPhone, onFitChange) {
    var root = document.getElementById('fsp-designer');
    var wrap = document.getElementById('fspd-stage-wrap');
    if (!root || !wrap || !window.FSPD || !window.FSPD.canvas) { return null; }
    var canvas = window.FSPD.canvas;
    var $ = function (id) { return document.getElementById(id); };
    var home = { p: wrap.parentNode, n: wrap.nextSibling };
    var h1 = root.querySelector('h1');
    var title = h1 && h1.firstChild ? String(h1.firstChild.textContent || '').trim() : 'Your sign';
    var ic = function (k) { return SVG(IC[k]).replace('width="26" height="26"', 'width="24" height="24"'); };
    var rb = function (a, icon, label) { return '<button type="button" class="fspk-rb" data-a="' + a + '">' + ic(icon) + '<span>' + label + '</span></button>'; };
    var el = document.createElement('div');
    el.className = 'fspk';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Sign designer');
    el.innerHTML =
      '<div class="fspk-top">' +
      '<button type="button" class="fspk-ghost" data-a="back">← Back to product</button>' +
      '<div class="fspk-name"></div>' +
      '<button type="button" class="fspk-tbb" data-a="undo">' + SVG(IC.undo).replace('width="26" height="26"', 'width="18" height="18"') + 'Undo</button>' +
      '<button type="button" class="fspk-tbb" data-a="redo">' + SVG(IC.redo).replace('width="26" height="26"', 'width="18" height="18"') + 'Redo</button>' +
      '<nav class="fspk-steps" aria-label="Steps"><button type="button" class="fspk-step" data-a="designs">1 Design</button><span aria-hidden="true">›</span>' +
      '<button type="button" class="fspk-step" data-a="words">2 Words</button><span aria-hidden="true">›</span>' +
      '<button type="button" class="fspk-step" data-a="pictures">3 Pictures</button><span aria-hidden="true">›</span>' +
      '<button type="button" class="fspk-step" data-a="finish">4 Check &amp; order</button></nav>' +
      '<button type="button" class="fspk-ghost" data-a="help">Help</button>' +
      '<button type="button" class="fspk-ghost" data-a="save">Save</button>' +
      '<button type="button" class="fspk-pill" data-a="finish">Finish</button></div>' +
      '<div class="fspk-body"><div class="fspk-rail">' +
      rb('designs', 'designs', 'Size &amp; designs') + rb('words', 'words', 'Words') + rb('pictures', 'pictures', 'Pictures') +
      rb('shapes', 'shapes', 'Shapes') + rb('bg', 'bg', 'Sign color') + rb('ai', 'ai', 'Design it for me') + '</div>' +
      '<section class="fspk-panel" hidden aria-labelledby="fspk-pt"><div class="fspk-ph"><div class="fspk-pt" id="fspk-pt" role="heading" aria-level="2"></div>' +
      '<button type="button" class="fspk-tbb" data-a="hide" aria-label="Close this panel">‹</button></div><div class="fspk-pb"></div></section>' +
      '<div class="fspk-center"><div class="fspk-tools"></div><div class="fspk-strip"><span class="fspk-k"><span class="fspk-kg"></span>Keep words and logos inside the green line</span>' +
      '<span class="fspk-k"><span class="fspk-kr"></span>The sign is cut on the red line</span>' +
      '<span class="fspk-gap"></span><button type="button" class="fspk-tbb" data-a="zout" aria-label="Zoom out">−</button><span class="fspk-zl">100%</span>' +
      '<button type="button" class="fspk-tbb" data-a="zin" aria-label="Zoom in">+</button><button type="button" class="fspk-tbb" data-a="zfit">Fit</button></div></div></div>' +
      '<div class="fspk-modal" hidden><div class="fspk-dlg" role="dialog" aria-modal="true" aria-labelledby="fspk-mt"><div class="fspk-mh">' +
      '<div class="fspk-mt" id="fspk-mt" role="heading" aria-level="2">Check &amp; order</div><button type="button" class="fspk-ghost" data-a="mclose">Back to design</button></div>' +
      '<div class="fspk-mb"></div></div></div>' +
      '<div class="fspk-toast" role="status" aria-live="polite"></div>';
    root.appendChild(el);
    var q = function (s) { return el.querySelector(s); };
    q('.fspk-name').textContent = title;
    q('.fspk-name').title = title;
    var tools = q('.fspk-tools'), center = q('.fspk-center'), strip = q('.fspk-strip'), panel = q('.fspk-panel'), pbody = q('.fspk-pb'), modal = q('.fspk-modal'), mbody = q('.fspk-mb');
    var hintEl = document.createElement('span');
    hintEl.className = 'fspk-hint';
    hintEl.textContent = 'Click anything on your sign to change it.';
    var pop = document.createElement('div');
    pop.className = 'fspk-pop';
    pop.hidden = true;
    pop.innerHTML = '<button type="button" data-a="copy">Copy</button><button type="button" class="is-danger" data-a="del">Delete</button>';
    var D = { on: false, panel: null, moved: [], mmoved: [], tmoved: [], zoom: 1, fitS: 1, scale: 1, busy: false };
    /* the Color button: the swatches open under it instead of filling a whole row */
    var colorBtn = document.createElement('button');
    colorBtn.type = 'button';
    colorBtn.className = 'fspk-tbb fspk-colorbtn';
    colorBtn.innerHTML = '<span class="fspk-dot"></span>Color';
    function colorRow() { var sw = $('fspd-fill-sw'); return sw && sw.closest('.fspd-prop'); }
    function dot() {
      var o = canvas.getActiveObject(), f = o && (typeof o.fill === 'string' ? o.fill : (o.getObjects && o.getObjects()[0] && o.getObjects()[0].fill));
      colorBtn.firstChild.style.background = typeof f === 'string' ? f : '#ffffff';
    }
    colorBtn.addEventListener('click', function (e) { e.stopPropagation(); var r = colorRow(); if (r) { r.classList.toggle('is-open'); } });
    document.addEventListener('click', function (e) {
      var r = colorRow();
      if (!D.on || !r || !r.classList.contains('is-open')) { return; }
      if (e.target.closest && e.target.closest('.fspd-swatches')) { setTimeout(function () { r.classList.remove('is-open'); dot(); }, 0); return; }
      if (!r.contains(e.target)) { r.classList.remove('is-open'); }
    });
    function sync() {
      el.classList.toggle('is-sel', !!canvas.getActiveObject());
      if (D.panel) { el.setAttribute('data-panel', D.panel); } else { el.removeAttribute('data-panel'); }
      Array.prototype.forEach.call(el.querySelectorAll('.fspk-rb,.fspk-step'), function (b) {
        var a = b.getAttribute('data-a');
        b.classList.toggle('is-on', a === 'finish' ? !modal.hidden : (D.panel === a || (a === 'shapes' && D.panel === 'pictures' && D.shapes)));
      });
    }
    var toastT;
    function toast(msg, ms) {
      var t = q('.fspk-toast');
      t.textContent = msg;
      t.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { t.classList.remove('is-on'); }, ms || 3200);
    }
    function click(id) { var b = $(id); if (b && !b.disabled) { b.click(); return true; } return false; }
    function step(n) { var b = root.querySelectorAll('.fspd-step')[n - 1]; if (b) { b.click(); } }
    var PANEL_EL = Array.prototype.slice.call(root.querySelectorAll('.fspd-tools > .fspd-panel'));
    function panelN(i) { return PANEL_EL[i]; }

    /* the sign: as big as the space allows, times the zoom */
    function fit() {
      if (!D.on) { return; }
      var w = parseFloat(stage.style.width) || stage.offsetWidth, h = parseFloat(stage.style.height) || stage.offsetHeight;
      if (!w || !h) { return; }
      var others = 0;
      Array.prototype.forEach.call(wrap.children, function (c) {
        if (c === stage || c === pop) { return; }
        var cs = getComputedStyle(c);
        if (cs.display === 'none' || cs.position === 'absolute' || cs.position === 'fixed') { return; }
        others += c.offsetHeight + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
      });
      var availW = wrap.clientWidth - 64, availH = wrap.clientHeight - others - 56;
      var fitS = Math.max(0.2, Math.min(availW / w, availH / h, 3));
      var s = fitS * D.zoom;
      D.fitS = fitS;
      q('.fspk-zl').textContent = Math.round(D.zoom * 100) + '%';
      var ml = Math.max(24, Math.round((wrap.clientWidth - w * s) / 2));
      var mt = Math.max(16, Math.round((availH - h * s) / 2) + 16);
      if (Math.abs(s - D.scale) < 0.002 && stage.style.transform && stage.style.marginLeft === ml + 'px' && stage.style.marginTop === mt + 'px') { return; }
      D.scale = s;
      stage.style.transformOrigin = 'top left';
      stage.style.transform = 'scale(' + s.toFixed(4) + ')';
      stage.style.marginBottom = Math.round(h * (s - 1)) + 'px';
      stage.style.marginRight = Math.round(w * (s - 1)) + 'px';
      stage.style.marginLeft = ml + 'px';
      stage.style.marginTop = mt + 'px';
      var P = fabric.Object.prototype;
      P.cornerSize = Math.round(Math.max(D.keepCs || 16, 14 / s));
      canvas.requestRenderAll();
    }
    /* the toolbar keeps the tallest height it has needed, so the sign doesn't jump each time something is picked */
    var tallest = 0;
    function toolsH() { var h = tools.offsetHeight; if (h > tallest) { tallest = h; tools.style.minHeight = h + 'px'; } }
    window.addEventListener('resize', function () { tallest = 0; tools.style.minHeight = ''; });
    var fitQ = false;
    function fitSoon() { if (!fitQ) { fitQ = true; requestAnimationFrame(function () { fitQ = false; fit(); canvas.calcOffset(); popSoon(); }); } }
    if (window.ResizeObserver) { new ResizeObserver(fitSoon).observe(center); }
    new MutationObserver(fitSoon).observe(stage, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', fitSoon);

    /* the small Copy / Delete bar above the picked item */
    var popQ = false;
    function placePop() {
      popQ = false;
      var o = canvas.getActiveObject();
      if (!D.on || !o || D.busy || (o.isEditing)) { pop.hidden = true; return; }
      var up = canvas.upperCanvasEl.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
      var k = up.width / (canvas.getWidth() || 1), b = o.getBoundingRect();
      var x = up.left - wr.left + wrap.scrollLeft + (b.left + b.width / 2) * k;
      var y = up.top - wr.top + wrap.scrollTop + b.top * k - 14;
      if (y - 46 < wrap.scrollTop + 8) { y = up.top - wr.top + wrap.scrollTop + (b.top + b.height) * k + 60; }
      pop.style.left = Math.round(x) + 'px';
      pop.style.top = Math.round(y) + 'px';
      pop.hidden = false;
    }
    function popSoon() { if (!popQ) { popQ = true; requestAnimationFrame(placePop); } }
    canvas.on('after:render', function () { if (D.on) { popSoon(); } });
    ['object:moving', 'object:scaling', 'object:rotating'].forEach(function (ev) { canvas.on(ev, function () { if (D.on) { D.busy = true; pop.hidden = true; } }); });
    canvas.on('mouse:up', function () { if (D.busy) { D.busy = false; popSoon(); } });
    ['selection:created', 'selection:updated', 'selection:cleared'].forEach(function (ev) {
      canvas.on(ev, function () { setTimeout(function () { if (D.on) { sync(); dot(); var r = colorRow(); if (r) { r.classList.remove('is-open'); } toolsH(); fitSoon(); } }, 0); });
    });
    wrap.addEventListener('scroll', function () { if (D.on) { popSoon(); } });

    /* the panel beside the sign: it holds the designer's own controls, moved in and put back */
    var callA = root.querySelector('.fspd-phone');
    var tel = callA ? callA.getAttribute('href') : 'tel:+15617472377';
    var telText = callA ? callA.textContent.trim() : '(561) 747-2377';
    var PANELS = {
      designs: { t: 'Size & designs', step: 1, nodes: function () { return [$('fspd-draft'), panelN(0)]; }, after: '<button type="button" class="fspk-big" data-a="startover">Start over with a blank sign</button>' },
      words: { t: 'Your words', step: 2, nodes: function () { return [panelN(1)]; } },
      pictures: { t: 'Pictures & extras', step: 3, nodes: function () { return [panelN(2)]; } },
      bg: { t: 'Sign color', nodes: function () { var b = $('fspd-bg-sw'); return [b && b.closest('details')]; }, open: true },
      ai: { t: 'Design it for me', nodes: function () { return [$('fspd-sec-ai')]; }, open: true },
      save: { t: 'Save your design', nodes: function () { return [$('fspd-savebar'), $('fspd-savebox')]; } },
      help: {
        t: 'Help', html: '<div class="fspk-call">Stuck, or rather talk to a person? Call <a href="' + tel + '">' + telText + '</a> and we’ll help you.</div>' +
          '<button type="button" class="fspk-big" data-a="chat">Chat with us</button>' +
          '<p class="fspk-note"><b>How it works:</b> pick a tool on the left and it opens here. Click anything on your sign and every tool for it shows above the sign. Drag to move it, drag a corner to resize it.</p>' +
          '<p class="fspk-note"><b>Handy keys</b> (click the sign first): arrow keys nudge the picked item (hold Shift for bigger steps), Delete removes it, Ctrl+Z undoes, Ctrl+D copies, Esc lets go of it.</p>' +
          '<button type="button" class="fspk-big" data-a="classic">Use the classic layout instead</button>'
      }
    };
    function restore(list) {
      for (var i = list.length - 1; i >= 0; i--) {
        var m = list[i];
        try { m.p.insertBefore(m.n, m.nx && m.nx.parentNode === m.p ? m.nx : null); } catch (e) { }
      }
      list.length = 0;
    }
    function moveIn(list, nodes, into, openDetails) {
      nodes.forEach(function (n) {
        if (!n) { return; }
        list.push({ n: n, p: n.parentNode, nx: n.nextSibling });
        into.appendChild(n);
        if (openDetails && n.tagName === 'DETAILS') { n.open = true; }
      });
    }
    function closePanel() {
      if (!D.panel) { return; }
      restore(D.moved);
      pbody.innerHTML = '';
      panel.hidden = true;
      D.panel = null;
      D.shapes = false;
      sync();
      fitSoon();
    }
    function openPanel(name) {
      var d = PANELS[name];
      if (!d) { return; }
      closePanel();
      if (d.step) { step(d.step); }
      D.panel = name;
      q('#fspk-pt').textContent = d.t;
      if (d.nodes) { moveIn(D.moved, d.nodes(), pbody, d.open); }
      if (d.html) { pbody.insertAdjacentHTML('beforeend', d.html); }
      if (d.after) { pbody.insertAdjacentHTML('beforeend', d.after); }
      panel.hidden = false;
      pbody.scrollTop = 0;
      sync();
      fitSoon();
    }
    function toggle(name) { if (D.panel === name && !D.shapes) { closePanel(); } else { openPanel(name); } }
    function openFinish() {
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      step(4);
      restore(D.mmoved);
      moveIn(D.mmoved, [panelN(3)], mbody, false);
      modal.hidden = false;
      sync();
      var f = mbody.querySelector('button, input, select, textarea');
      q('[data-a="mclose"]').focus();
    }
    function closeFinish(keepStep) {
      if (modal.hidden) { return; }
      restore(D.mmoved);
      modal.hidden = true;
      var back = { designs: 1, words: 2, pictures: 3 }[D.panel];
      if (back && keepStep !== true) { step(back); }
      sync();
      fitSoon();
    }
    var ACT = {
      back: function () { location.href = location.pathname; },
      classic: function () { try { localStorage.setItem('fspk:classic', '1'); } catch (e) { } close(); },
      undo: function () { click('fspd-undo'); }, redo: function () { click('fspd-redo'); },
      designs: function () { toggle('designs'); }, words: function () { toggle('words'); }, pictures: function () { toggle('pictures'); },
      bg: function () { toggle('bg'); }, ai: function () { toggle('ai'); },
      save: function () { openPanel('save'); }, help: function () { openPanel('help'); }, hide: function () { closePanel(); },
      shapes: function () {
        if (D.panel === 'pictures' && D.shapes) { closePanel(); return; }
        openPanel('pictures');
        D.shapes = true;
        var g = pbody.querySelectorAll('details.fspd-group');
        for (var i = 0; i < g.length; i++) {
          var s = g[i].querySelector('summary');
          if (s && /shape/i.test(s.textContent)) { g[i].open = true; g[i].scrollIntoView({ block: 'start' }); break; }
        }
        sync();
      },
      finish: openFinish, mclose: closeFinish,
      chat: function () { if (!click('fspd-chat')) { toast('Chat isn’t available right now. Please call us.'); } },
      startover: function () { click('fspd-startover'); },
      copy: function () { click('fspd-dup'); },
      del: function () { if (click('fspd-del')) { toast('Deleted. Changed your mind? Click Undo at the top.'); } },
      zin: function () { D.zoom = Math.min(2, Math.round((D.zoom + 0.1) * 10) / 10); D.scale = -1; fitSoon(); },
      zout: function () { D.zoom = Math.max(0.5, Math.round((D.zoom - 0.1) * 10) / 10); D.scale = -1; fitSoon(); },
      zfit: function () { D.zoom = 1; D.scale = -1; fitSoon(); }
    };
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button');
      if (!b || !el.contains(b)) { return; }
      var a = b.getAttribute('data-a');
      if (a && ACT[a] && !b.closest('.fspd-panel')) { e.preventDefault(); ACT[a](); return; }
      if (D.panel === 'designs' && b.closest('#fspd-tpl-grid, #fspd-blank')) { setTimeout(function () { if (D.panel === 'designs') { openPanel('words'); } }, 350); }
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) { closeFinish(); } });
    /* a fix button in the Check & order list ("Change the words", "Show me"): close the window and open the right panel */
    mbody.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest('#fspd-checks button'))) { return; }
      setTimeout(function () {
        var i = -1;
        PANEL_EL.forEach(function (p, k) { if (p.classList.contains('is-on')) { i = k; } });
        closeFinish(true);
        var name = ['designs', 'words', 'pictures'][i];
        if (name && D.panel !== name) { openPanel(name); }
      }, 60);
    });
    document.addEventListener('keydown', function (e) {
      if (!D.on || e.key !== 'Escape') { return; }
      if (!modal.hidden) { closeFinish(); return; }
      var o = canvas.getActiveObject(), typing = /INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '') || (o && o.isEditing);
      if (o && !typing) { canvas.discardActiveObject(); canvas.requestRenderAll(); }
    });
    function hist() {
      ['undo', 'redo'].forEach(function (k) { var src = $('fspd-' + k); q('[data-a="' + k + '"]').disabled = !!(src && src.disabled); });
    }
    ['fspd-undo', 'fspd-redo'].forEach(function (id) { var b = $(id); if (b) { new MutationObserver(hist).observe(b, { attributes: true, attributeFilter: ['disabled'] }); } });
    var aiSec = $('fspd-sec-ai');
    function aiBtn() { q('.fspk-rb[data-a="ai"]').hidden = !aiSec || aiSec.hidden; }
    if (aiSec) { new MutationObserver(aiBtn).observe(aiSec, { attributes: true, attributeFilter: ['hidden'] }); }

    /* the regular tour points at the regular layout */
    new MutationObserver(function (ms) {
      if (!D.on) { return; }
      ms.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && n.classList.contains('fspd-tour')) {
            var skip = n.querySelector('.fspd-tour-skip');
            setTimeout(function () { if (skip) { skip.click(); } else if (n.parentNode) { n.parentNode.removeChild(n); } openPanel('help'); }, 0);
          }
        });
      });
    }).observe(document.body, { childList: true });

    function open() {
      if (D.on || mqPhone.matches) { return; }
      D.on = true;
      D.scale = -1;
      D.keepCs = fabric.Object.prototype.cornerSize;
      center.insertBefore(wrap, strip);
      wrap.appendChild(pop);
      var sb = wrap.querySelector('.fspd-stagebar');
      moveIn(D.tmoved, [sb, $('fspd-props')], tools, false);
      if (sb) { sb.appendChild(hintEl); }
      var cr = colorRow();
      if (cr) { cr.insertBefore(colorBtn, cr.firstChild); }
      el.hidden = false;
      document.documentElement.classList.add('fspk-on');
      document.body.classList.add('fspk-on');
      aiBtn();
      var bgd = $('fspd-bg-sw');
      bgd = bgd && bgd.closest('details');
      q('.fspk-rb[data-a="bg"]').hidden = !bgd || bgd.hidden || getComputedStyle(bgd).display === 'none';
      q('.fspk-ghost[data-a="save"]').hidden = !$('fspd-save');
      var shapesG = Array.prototype.some.call(root.querySelectorAll('details.fspd-group summary'), function (s) {
        var d = s.parentNode;
        return /shape/i.test(s.textContent) && !d.hidden && getComputedStyle(d).display !== 'none';
      });
      q('.fspk-rb[data-a="shapes"]').hidden = !shapesG;
      hist();
      openPanel(canvas.getObjects().length ? 'words' : 'designs');
      sync();
      fit();
      canvas.calcOffset();
      onFitChange && onFitChange();
      var seen = null;
      try { seen = localStorage.getItem('fspk:tips'); localStorage.setItem('fspk:tips', '1'); } catch (e) { }
      if (!seen) { toast('Pick a tool on the left. Click anything on your sign to change it: its tools show above the sign.', 6000); }
    }
    function close() {
      if (!D.on) { return; }
      closeFinish();
      closePanel();
      D.on = false;
      if (pop.parentNode) { pop.parentNode.removeChild(pop); }
      if (hintEl.parentNode) { hintEl.parentNode.removeChild(hintEl); }
      if (colorBtn.parentNode) { colorBtn.parentNode.removeChild(colorBtn); }
      var cr = colorRow();
      if (cr) { cr.classList.remove('is-open'); }
      restore(D.tmoved);
      home.p.insertBefore(wrap, home.n && home.n.parentNode === home.p ? home.n : null);
      el.hidden = true;
      document.documentElement.classList.remove('fspk-on');
      document.body.classList.remove('fspk-on');
      stage.style.transform = '';
      stage.style.marginBottom = stage.style.marginRight = stage.style.marginLeft = stage.style.marginTop = '';
      if (D.keepCs) { fabric.Object.prototype.cornerSize = D.keepCs; }
      canvas.requestRenderAll();
      onFitChange && onFitChange();
      stage.scrollIntoView({ block: 'center' });
      requestAnimationFrame(function () { canvas.calcOffset(); });
    }
    if (mqPhone.addEventListener) {
      mqPhone.addEventListener('change', function () {
        if (mqPhone.matches) { close(); }
        else { setTimeout(function () { var c = null; try { c = localStorage.getItem('fspk:classic'); } catch (e) { } if (!c) { open(); } }, 0); }
      });
    }
    return { open: open, close: close, isOn: function () { return D.on; } };
  }

  function start() {
    aiRules();
    var stage = document.getElementById('fspd-stage');
    var col = document.querySelector('.fspd-stage-col');
    if (!stage || !col) { return; }
    var css = document.createElement('style');
    css.textContent = STUDIO_CSS + DESK_CSS +
      '.fspd-mini{position:fixed;left:8px;right:8px;z-index:40;display:none;align-items:center;gap:8px;' +
      'padding:6px 8px;border:1px solid #c9d3e0;border-radius:10px;background:#fff;box-shadow:0 4px 14px rgba(0,0,0,.18);cursor:pointer;font:inherit}' +
      '.fspd-mini.is-on{display:flex}.fspd-mini__label{font-size:12px;font-weight:600;color:#1f3a5f;white-space:nowrap}' +
      '.fspd-mini__cv{display:block;margin:0 auto;max-width:calc(100% - 70px);height:auto;background:#fff}';
    document.head.appendChild(css);
    var studio = null, desk = null;

    /* regular page on a phone: the sign is enlarged to the width of the screen */
    var scale = 1;
    function fit() {
      if ((studio && studio.isOn()) || (desk && desk.isOn())) { return; }
      var w = parseFloat(stage.style.width) || stage.offsetWidth;
      var h = parseFloat(stage.style.height) || stage.offsetHeight;
      if (!w || !h) { return; }
      var s = 1;
      if (mq.matches) {
        var cs = getComputedStyle(col);
        var avail = col.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2;
        s = Math.min(avail / w, window.innerHeight * 0.55 / h, 3);
        if (s < 1.02) { s = 1; }
      }
      var hasScale = stage.style.transform !== '';
      if (Math.abs(s - scale) < 0.001 && hasScale === (s > 1)) { return; }
      scale = s;
      stage.style.transformOrigin = 'top left';
      stage.style.transform = s > 1 ? 'scale(' + s.toFixed(4) + ')' : '';
      stage.style.marginBottom = s > 1 ? Math.round(h * (s - 1)) + 'px' : '';
      stage.style.marginRight = s > 1 ? Math.round(w * (s - 1)) + 'px' : '';
      stage.style.marginLeft = '';
    }
    new MutationObserver(fit).observe(stage, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', fit);
    fit();

    /* a tap up to 10 pixels off an item still selects it (phones only) */
    var tries = 0;
    (function tol() {
      if (window.fabric && fabric.Canvas) {
        fabric.Canvas.prototype.targetFindTolerance = mq.matches ? 10 : 4;
        if (window.FSPD && window.FSPD.canvas) { window.FSPD.canvas.targetFindTolerance = mq.matches ? 10 : 4; }
      } else if (tries++ < 40) { setTimeout(tol, 250); return; }
      if (mq.addEventListener && !tol.on) { tol.on = true; mq.addEventListener('change', tol); }
    })();

    /* the full-screen studio; it opens by itself on phones */
    var big = document.createElement('button');
    big.type = 'button';
    big.className = 'fspd-bigbtn';
    big.textContent = 'Open the full-screen designer';
    stage.insertAdjacentElement('afterend', big);
    var waits = 0;
    (function boot() {
      if (!window.fabric || !window.FSPD || !window.FSPD.canvas || !(parseFloat(stage.style.width) > 0)) {
        if (waits++ < 60) { setTimeout(boot, 250); }
        return;
      }
      var refit = function () { scale = -1; fit(); };
      desk = makeDesk(stage, mq, refit);
      studio = makeStudio(stage, mq, refit);
      if (!studio && !desk) { big.hidden = true; return; }
      var classic = function () { try { return !!localStorage.getItem('fspk:classic'); } catch (e) { return false; } };
      big.addEventListener('click', function () {
        if (mq.matches) { if (studio) { studio.open(); } }
        else if (desk) { try { localStorage.removeItem('fspk:classic'); } catch (e) { } desk.open(); }
      });
      if (mq.matches) { if (studio) { studio.open(); } }
      else if (desk && !classic()) { desk.open(); }
      /* switching between phone and computer size (some browsers don't report it): close one layout, then open the other */
      var wasPhone = mq.matches;
      window.addEventListener('resize', function () {
        if (mq.matches === wasPhone) { return; }
        wasPhone = mq.matches;
        if (wasPhone) { if (desk) { desk.close(); } if (studio && !studio.userClosed()) { studio.open(); } }
        else { if (studio) { studio.close(); } if (desk && !classic()) { desk.open(); } }
      });
    })();

    /* regular page: a small live copy of the sign stays pinned under the header while typing further down */
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'fspd-mini';
    bar.setAttribute('aria-label', 'Your sign preview. Tap to see the full preview.');
    bar.innerHTML = '<span class="fspd-mini__label">Your sign</span><canvas class="fspd-mini__cv"></canvas>';
    document.body.appendChild(bar);
    var cv = bar.querySelector('canvas');
    var ctx = cv.getContext('2d');
    function headerBottom() {
      var el = document.elementFromPoint(window.innerWidth / 2, 2);
      while (el && el !== document.body) {
        var p = getComputedStyle(el).position;
        if (p === 'fixed' || p === 'sticky') { return Math.max(0, el.getBoundingClientRect().bottom); }
        el = el.parentElement;
      }
      return 0;
    }
    function draw() {
      var src = stage.querySelector('canvas.lower-canvas') || stage.querySelector('canvas');
      if (!src || !src.width) { return false; }
      var maxH = Math.round(window.innerHeight * 0.16);
      var maxW = bar.clientWidth - 78;
      var r = Math.min(maxW / src.width, maxH / src.height);
      var w = Math.max(1, Math.round(src.width * r));
      var h = Math.max(1, Math.round(src.height * r));
      var dpr = window.devicePixelRatio || 1;
      if (cv.width !== w * dpr) { cv.width = w * dpr; cv.height = h * dpr; cv.style.width = w + 'px'; cv.style.height = h + 'px'; }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, cv.width, cv.height);
      ctx.drawImage(src, 0, 0, cv.width, cv.height);
      return true;
    }
    function offScreen(hb) {
      var r = stage.getBoundingClientRect();
      if (!r.height) { return false; }
      var shown = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, hb);
      return shown < r.height * 0.25;
    }
    var queued = false;
    function update() {
      queued = false;
      var on = false;
      if (mq.matches && !(studio && studio.isOn()) && stage.offsetParent !== null) {
        var hb = headerBottom();
        if (offScreen(hb)) { bar.style.top = (hb + 6) + 'px'; on = draw(); }
      }
      bar.classList.toggle('is-on', !!on);
    }
    function soon() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    setInterval(function () { if (mq.matches) { update(); } }, 500);
    bar.addEventListener('click', function () {
      var y = stage.getBoundingClientRect().top + window.pageYOffset - headerBottom() - 70;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();